import {
    Anchor,
    Box,
    Button,
    Flex,
    Grid,
    PasswordInput,
    Space,
    Stack,
    Text,
    TextInput,
    UnstyledButton,
} from '@mantine/core'
import {
    GhostIcon,
    HatGlasses,
    LogIn,
    UserPlus,
} from 'lucide-react'
import { Controller } from 'react-hook-form'

import { Form } from '@/components/atoms/Form'

import ModalHeader from '../../shared/ModalHeader/ModalHeader'

import { FeatureFlagContext } from '@/contexts/FeatureFlagsContext'
import { useContext } from 'react'
import { useViewModel } from './SignIn.vm'

export const SignInTitle = () => {
    const metadata = {
        title: 'Finalisez votre commande',
        description: 'Connectez-vous à votre compte ou commandez en tant qu\'invité',

    }

    return <ModalHeader {...metadata} />
}

export const SignIn = () => {
    const viewModel = useViewModel()
    const { isFeatureEnabled } = useContext(FeatureFlagContext)
    return (
        <Box className="w-full overflow-hidden p-4">
            {/* Cart header */}
            <Space h="1rem" mb="xl" />
            {/* If there is a cart and cart has items then show all line items */}
            <Form onSubmit={viewModel.onSubmit}>
                <Grid>
                    <Grid.Col w="100%">
                        <Stack w="100%">
                            <Controller
                                control={viewModel.control}
                                name="email"
                                render={({ field, fieldState, formState }) => (
                                    <TextInput
                                        label="E-mail"
                                        disabled={formState.isSubmitting}
                                        placeholder="ex. email@email.com"
                                        value={field.value}
                                        onChange={field.onChange}
                                        error={fieldState.error?.message}
                                    />
                                )}
                            />

                            <Controller
                                control={viewModel.control}
                                name="password"
                                render={({ field, fieldState, formState }) => (
                                    <PasswordInput
                                        label="Mot de passe"
                                        disabled={formState.isSubmitting}
                                        placeholder="ex. ******"
                                        value={field.value}
                                        onChange={field.onChange}
                                        error={fieldState.error?.message}
                                    />
                                )}
                            />
                            <Anchor
                                href="/sign-in?reset=true"
                                color="gray"
                                size="xs"
                                mt={2}
                            >
                                Mot de passe oublié ?
                            </Anchor>
                        </Stack>
                    </Grid.Col>
                    <Grid.Col w="100%" mt="sm">
                        <Stack align="center" spacing="xs">              
                                <Button
                                    fullWidth
                                    type="submit"
                                    loading={
                                        viewModel.control._formState
                                            .isSubmitting
                                    }
                                    disabled={
                                        viewModel.control._formState
                                            .isSubmitting
                                    }
                                    leftIcon={
                                        <LogIn className="w-4 h-4" />
                                    }
                                >
                                    Se connecter
                                </Button>        
                        </Stack>
                        
                    </Grid.Col>
                   
                        <Grid.Col w="100%" mt="sm">
                            <Stack align="center" spacing="xs">
                                <Text size="sm" c="gray.5" fw={500}>Ou</Text>
                                  <Button
                                    fullWidth
                                    color="gray"
                                    variant="light"
        
                                    onClick={viewModel.onRegisterAccount}
                                    disabled={
                                        viewModel.control._formState
                                            .isSubmitting
                                    }
                                    leftIcon={
                                        <UserPlus className="w-4 h-4" />
                                    }
                                >
                                    Créer un compte
                                </Button>
                                 {isFeatureEnabled('anonymous_cart') && (
                                <Button
                                    type="submit"
                                    onClick={viewModel.onAnonymous}
                                    variant="subtle"
                                    fullWidth
                                    c="black"
                                    td="underline"
                                    sx={{ '&:hover': { background: 'transparent' } }}
                                >
                                    Continuer en tant qu'invité
                                </Button>
                                    )}
                            </Stack>
                        </Grid.Col>
               
                </Grid>
            </Form>
        </Box>
    )
}
